import { TextBox, TextBoxField } from "./textBox.js";
import { Button } from "./button.js";
import { NotificationHelper } from "../util/notificationHelper.js";
import { HTTPService, JsonResultClass } from "../util/httpManager.js";
import { Helper } from "../util/helper.js";
import { field } from "./editableGrid/editableGrid.js";
import { BaseComponentProps, BaseField } from "./baseComponentProps.js";
import React from "react";
export class GetNextNumber extends React.Component<GetNextNumberProps, any>{

    private getNextNumber = async () => {
        try {
            let url = Helper.processTemplate(this.props.field.url, ((match) => {
                const result = this.props.handleEval(match).toString();
                if (!Helper.isNullOrEmpty(result)) {
                    return encodeURIComponent(result);
                } else {
                    return "";
                }
            }));

            const result = await HTTPService.get<JsonResultClass>(url);
            if (result.Code === 0) {
                //AG - hier direct Wert ins Control setzen, weil es wird vom Keno validiert 
                var nl = document.getElementsByName(this.props.field.model);
                if (nl.length == 1 && Helper.hasValue(result.Id)) {
                    if (nl[0].tagName == 'INPUT') {
                        const el = nl[0] as HTMLInputElement;
                        if (el.value === '' && !el.readOnly) {
                            el.value = result.Id;
                        }
                    }
                }
                this.onChange(this.props.field, result.Id, null);
            } else {
                NotificationHelper.showErrorMessage(result.Message);
            }
        } catch {
            throw new Error("Could not get next available number at URL: " + this.props.field.url);
        }
    }


    private onChange = (field, value: string, dataItem) => {
        const maxLenght = this.props.field.maxLength;
        if (Helper.hasValue(maxLenght) && maxLenght > 0 && !Helper.isNullOrEmpty(value)) {
            value = value.substring(0, maxLenght);
        }
        this.props.onChange(field, value, dataItem);
    }


    private copyToClipBoard = () => {
        navigator.clipboard.writeText(this.props.value);
        NotificationHelper.showSuccessMessage(Helper.getTranslation("Standard.SavedToClipboard"))
    }

    render() {
        const field = this.props.field as TextBoxField;
        field.triggerOnChange = true;
        field.maxLength = this.props.field.maxLength;


        return (
            <div style={{ display: "flex", alignItems: "center" }} className="is-get-next-number" data-readonly={this.props.disabled} >
                <div style={{ flex: 1, width: "100%" }} >
                    <TextBox value={this.props.value} field={field} disabled={this.props.disabled} onChange={this.onChange} required={this.props.required} />
                </div>
                {this.props.disabled ? null : <>
                    <Button iconName="reply" handleClick={this.getNextNumber} buttonStyle={{ display: this.props.disabled ? "none" : "inline-flex", borderColor: "#ced4da", borderLeft: "none", height: "38px", width: "30px", backgroundColor: "rgb(228, 231, 235)" }} />
                </>}

                {window.isSecureContext && Helper.hasValue(this.props.value) ? <Button iconName="paste" handleClick={this.copyToClipBoard} buttonStyle={{ display: Helper.hasValue(this.props.value) ? "inline-flex" : "none", borderColor: "#ced4da", borderLeft: "none", height: "38px", width: "30px", backgroundColor: "rgb(228, 231, 235)" }} /> : null}

            </div>
        );
    }
};
export interface GetNextNumberProps extends BaseComponentProps {
    onDataLoaded?(field: { model: string }, data: any);
    field: GetNextNumberField;
    handleEval?(action: string, prepare?: any);
}

export interface GetNextNumberField extends BaseField {
    url: string;
    maxLength?: number;
    triggerOnChange?: boolean;
    numbersOnly?: boolean;
}